const TYPE_CONVERSATION_EVENT = 'conversation_event';
const TYPE_FACEBOOK = 'facebook';
const TYPE_INSTAGRAM = 'instagram';
const TYPE_FORM_RESPONSE = 'form_response';
const TYPE_GECKO_CHAT = 'gecko_chat';
const TYPE_INTERNAL_NOTE = 'internal_note';
const TYPE_LIVE_CHAT = 'live_chat';
const TYPE_MAILGUN = 'mailgun';
const TYPE_PRACTICE_CHAT = 'practice_chat';
const TYPE_SYSTEM_INFORMATION = 'system_information';
const TYPE_TWILIO = 'twilio';
const TYPE_TWITTER = 'twitter';
const TYPE_WECHAT = 'wechat';
const TYPE_WHATSAPP = 'whatsapp';

const TYPES = [
  TYPE_CONVERSATION_EVENT,
  TYPE_FACEBOOK,
  TYPE_INSTAGRAM,
  TYPE_FORM_RESPONSE,
  TYPE_GECKO_CHAT,
  TYPE_INTERNAL_NOTE,
  TYPE_LIVE_CHAT,
  TYPE_MAILGUN,
  TYPE_PRACTICE_CHAT,
  TYPE_SYSTEM_INFORMATION,
  TYPE_TWILIO,
  TYPE_TWITTER,
  TYPE_WECHAT,
  TYPE_WHATSAPP,
];

const PICKABLE_TYPES = [
  TYPE_LIVE_CHAT,
  TYPE_FACEBOOK,
  TYPE_INSTAGRAM,
  TYPE_TWILIO,
  TYPE_TWITTER,
  TYPE_MAILGUN,
  TYPE_WECHAT,
  TYPE_WHATSAPP,
];

const UNPICKABLE_TYPES = [
  TYPE_INTERNAL_NOTE,
  TYPE_GECKO_CHAT,
  TYPE_SYSTEM_INFORMATION,
  TYPE_FORM_RESPONSE,
  TYPE_CONVERSATION_EVENT,
  TYPE_PRACTICE_CHAT,
];

const COMPOSABLE_TYPES = [TYPE_TWILIO, TYPE_MAILGUN];

const NAME_GECKO_CHAT = 'Gecko Chat';
const NAME_CONVERSATION_EVENT = 'Conversation Event';
const NAME_FACEBOOK = 'Facebook';
const NAME_INSTAGRAM = 'Instagram';
const NAME_FORM_RESPONSE = 'Form Response';
const NAME_INTERNAL_NOTE = 'Internal Note';
const NAME_LIVE_CHAT = 'Live Chat';
const NAME_MAILGUN = 'Email';
const NAME_PRACTICE_CHAT = 'Practice Channel';
const NAME_SYSTEM_INFORMATION = 'System Information';
const NAME_TWILIO = 'SMS';
const NAME_TWITTER = 'Twitter';
const NAME_WECHAT = 'WeChat';
const NAME_WHATSAPP = 'WhatsApp';

const BRAND_COLOUR_GECKO_CHAT = '428bca';
const BRAND_COLOUR_CONVERSATION_EVENT = '#428bca';
const BRAND_COLOUR_FACEBOOK = '#314681';
const BRAND_COLOUR_INSTAGRAM = '#833AB4';
const BRAND_COLOUR_FORM_RESPONSE = '#428bca';
const BRAND_COLOUR_INTERNAL_NOTE = '#fffdef';
const BRAND_COLOUR_LIVE_CHAT = '#9ADBE8';
const BRAND_COLOUR_MAILGUN = '#000000';
const BRAND_COLOUR_PRACTICE_CHAT = '#9ADBE8';
const BRAND_COLOUR_SYSTEM_INFORMATION = '#428bca';
const BRAND_COLOUR_TWILIO = '#63cb42';
const BRAND_COLOUR_TWITTER = '#3f8de8';
const BRAND_COLOUR_WECHAT = '#7bb32e';
const BRAND_COLOUR_WHATSAPP = '#48c64e';

const ICON_CONVERSATION_EVENT = 'fa fa-info-circle';
const ICON_GECKO_CHAT = 'fa fa-info-circle';
const ICON_FACEBOOK = 'fab fa-facebook-f';
const ICON_INSTAGRAM = 'fab fa-instagram';
const ICON_FORM_RESPONSE = 'fa fa-list';
const ICON_INTERNAL_NOTE = 'far fa-sticky-note';
const ICON_LIVE_CHAT = 'far fa-comments';
const ICON_MAILGUN = 'far fa-envelope';
const ICON_PRACTICE_CHAT = 'far fa-comments';
const ICON_SYSTEM_INFORMATION = 'far fa-info-circle';
const ICON_TWILIO = 'far fa-comment-dots';
const ICON_TWITTER = 'fab fa-twitter';
const ICON_WECHAT = 'fab fa-weixin';
const ICON_WHATSAPP = 'fab fa-whatsapp';

const DETAILS = {
  [TYPE_CONVERSATION_EVENT]: {
    TYPE: TYPE_CONVERSATION_EVENT,
    NAME: NAME_CONVERSATION_EVENT,
    BRAND_COLOUR: BRAND_COLOUR_CONVERSATION_EVENT,
    ICON: ICON_CONVERSATION_EVENT,
  },
  [TYPE_FACEBOOK]: {
    TYPE: TYPE_FACEBOOK,
    NAME: NAME_FACEBOOK,
    BRAND_COLOUR: BRAND_COLOUR_FACEBOOK,
    ICON: ICON_FACEBOOK,
  },
  [TYPE_INSTAGRAM]: {
    TYPE: TYPE_INSTAGRAM,
    NAME: NAME_INSTAGRAM,
    BRAND_COLOUR: BRAND_COLOUR_INSTAGRAM,
    ICON: ICON_INSTAGRAM,
  },
  [TYPE_FORM_RESPONSE]: {
    TYPE: TYPE_FORM_RESPONSE,
    NAME: NAME_FORM_RESPONSE,
    BRAND_COLOUR: BRAND_COLOUR_FORM_RESPONSE,
    ICON: ICON_FORM_RESPONSE,
  },
  [TYPE_GECKO_CHAT]: {
    TYPE: TYPE_GECKO_CHAT,
    NAME: NAME_GECKO_CHAT,
    BRAND_COLOUR: BRAND_COLOUR_GECKO_CHAT,
    ICON: ICON_GECKO_CHAT,
  },
  [TYPE_INTERNAL_NOTE]: {
    TYPE: TYPE_INTERNAL_NOTE,
    NAME: NAME_INTERNAL_NOTE,
    BRAND_COLOUR: BRAND_COLOUR_INTERNAL_NOTE,
    ICON: ICON_INTERNAL_NOTE,
  },
  [TYPE_LIVE_CHAT]: {
    TYPE: TYPE_LIVE_CHAT,
    NAME: NAME_LIVE_CHAT,
    BRAND_COLOUR: BRAND_COLOUR_LIVE_CHAT,
    ICON: ICON_LIVE_CHAT,
  },
  [TYPE_MAILGUN]: {
    TYPE: TYPE_MAILGUN,
    NAME: NAME_MAILGUN,
    BRAND_COLOUR: BRAND_COLOUR_MAILGUN,
    ICON: ICON_MAILGUN,
  },
  [TYPE_PRACTICE_CHAT]: {
    TYPE: TYPE_PRACTICE_CHAT,
    NAME: NAME_PRACTICE_CHAT,
    BRAND_COLOUR: BRAND_COLOUR_PRACTICE_CHAT,
    ICON: ICON_PRACTICE_CHAT,
  },
  [TYPE_SYSTEM_INFORMATION]: {
    TYPE: TYPE_SYSTEM_INFORMATION,
    NAME: NAME_SYSTEM_INFORMATION,
    BRAND_COLOUR: BRAND_COLOUR_SYSTEM_INFORMATION,
    ICON: ICON_SYSTEM_INFORMATION,
  },
  [TYPE_TWILIO]: {
    TYPE: TYPE_TWILIO,
    NAME: NAME_TWILIO,
    BRAND_COLOUR: BRAND_COLOUR_TWILIO,
    ICON: ICON_TWILIO,
  },
  [TYPE_TWITTER]: {
    TYPE: TYPE_TWITTER,
    NAME: NAME_TWITTER,
    BRAND_COLOUR: BRAND_COLOUR_TWITTER,
    ICON: ICON_TWITTER,
  },
  [TYPE_WECHAT]: {
    TYPE: TYPE_WECHAT,
    NAME: NAME_WECHAT,
    BRAND_COLOUR: BRAND_COLOUR_WECHAT,
    ICON: ICON_WECHAT,
  },
  [TYPE_WHATSAPP]: {
    TYPE: TYPE_WHATSAPP,
    NAME: NAME_WHATSAPP,
    BRAND_COLOUR: BRAND_COLOUR_WHATSAPP,
    ICON: ICON_WHATSAPP,
  },
};

module.exports = {
  TYPE_CONVERSATION_EVENT,
  TYPE_FACEBOOK,
  TYPE_INSTAGRAM,
  TYPE_FORM_RESPONSE,
  TYPE_GECKO_CHAT,
  TYPE_INTERNAL_NOTE,
  TYPE_LIVE_CHAT,
  TYPE_MAILGUN,
  TYPE_PRACTICE_CHAT,
  TYPE_SYSTEM_INFORMATION,
  TYPE_TWILIO,
  TYPE_TWITTER,
  TYPE_WECHAT,
  TYPE_WHATSAPP,
  TYPES,
  PICKABLE_TYPES,
  UNPICKABLE_TYPES,
  COMPOSABLE_TYPES,
  NAME_GECKO_CHAT,
  NAME_CONVERSATION_EVENT,
  NAME_FACEBOOK,
  NAME_INSTAGRAM,
  NAME_FORM_RESPONSE,
  NAME_INTERNAL_NOTE,
  NAME_LIVE_CHAT,
  NAME_MAILGUN,
  NAME_PRACTICE_CHAT,
  NAME_SYSTEM_INFORMATION,
  NAME_TWILIO,
  NAME_TWITTER,
  NAME_WECHAT,
  NAME_WHATSAPP,
  BRAND_COLOUR_GECKO_CHAT,
  BRAND_COLOUR_CONVERSATION_EVENT,
  BRAND_COLOUR_FACEBOOK,
  BRAND_COLOUR_INSTAGRAM,
  BRAND_COLOUR_FORM_RESPONSE,
  BRAND_COLOUR_INTERNAL_NOTE,
  BRAND_COLOUR_LIVE_CHAT,
  BRAND_COLOUR_MAILGUN,
  BRAND_COLOUR_PRACTICE_CHAT,
  BRAND_COLOUR_SYSTEM_INFORMATION,
  BRAND_COLOUR_TWILIO,
  BRAND_COLOUR_TWITTER,
  BRAND_COLOUR_WECHAT,
  BRAND_COLOUR_WHATSAPP,
  ICON_GECKO_CHAT,
  ICON_CONVERSATION_EVENT,
  ICON_FACEBOOK,
  ICON_INSTAGRAM,
  ICON_FORM_RESPONSE,
  ICON_INTERNAL_NOTE,
  ICON_LIVE_CHAT,
  ICON_MAILGUN,
  ICON_PRACTICE_CHAT,
  ICON_SYSTEM_INFORMATION,
  ICON_TWILIO,
  ICON_TWITTER,
  ICON_WECHAT,
  ICON_WHATSAPP,
  DETAILS,
};
